import { render } from "./search-autocomplete.vue?vue&type=template&id=6604df8d"
import script from "./search-autocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./search-autocomplete.vue?vue&type=script&setup=true&lang=js"

import "./search-autocomplete.vue?vue&type=style&index=0&id=6604df8d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/search-autocomplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6604df8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6604df8d', __exports__)) {
    api.reload('6604df8d', __exports__)
  }
  
  module.hot.accept("./search-autocomplete.vue?vue&type=template&id=6604df8d", () => {
    api.rerender('6604df8d', render)
  })

}


export default __exports__